<template>
    <div class="home-teacher-content">
        <ul class="profile-nav d-flex flex-wrap justify-content-center">
            <li class="profile-nav__item">
                <router-link
                        class="profile-nav__link"
                        :to="{ name: 'profile.edit' }"
                >
                    {{ $t('personal_data') }}
                </router-link>
            </li>

            <li class="profile-nav__item">
                <router-link
                        class="profile-nav__link"
                        :to="{ name: 'profile.students' }"
                >
                    {{ $t('students') }}
                </router-link>
            </li>

            <li class="profile-nav__item">
                <router-link
                        class="profile-nav__link"
                        :to="{ name: 'profile.courses' }"
                >
                  {{ $t('courses') }} (<span v-if="loading">0</span><span v-else-if="user && user.userCourses">{{ user.userCourses.length }}</span>)
                </router-link>
            </li>

            <li class="profile-nav__item">
                <router-link
                        class="profile-nav__link"
                        :to="{ name: 'profile.timetables' }"
                >
                    {{ $t('timetables') }}
                </router-link>
            </li>

            <!-- <li class="profile-nav__item">
                <router-link
                        class="profile-nav__link"
                        :to="{ name: 'profile.studies' }"
                >
                    {{ $t('study_products') }}
                </router-link>
            </li> -->

            <li class="profile-nav__item">
                <router-link
                        class="profile-nav__link"
                        :to="{ name: 'profile.medals' }"
                >
                    {{ $t('my_achievements') }}
                </router-link>
            </li>

            <li class="profile-nav__item" v-if="user.ref_id">
                <router-link
                        class="profile-nav__link"
                        :to="{ name: 'profile.ref-orders' }"
                >
                    {{ $t('referal_programm') }}
                </router-link>
            </li>
        </ul>

        <div class="profile-container">
            <h1 class="profile-title">{{ $t('account') }}</h1>
            <router-view/>
        </div>
    </div>
</template>

<script>
    import userApi from "../../data/UserApi";
    import SkeletonBox from '../SkeletonBox';

    export default {
        name: 'Wrapper',

        data() {
            return {
                user: {
                    email: null,
                    user: null,
                    ref_id: null,
                },
                loading: true,
            }
        },

        created() {
            userApi.fetchProfile()
                .then(response => {
                    this.user = response;
                    this.loading = false;
                });

        },

        components: {
            SkeletonBox
        }
    }
</script>

<style src="@/assets/hometeacher/css/main.css"></style>

<style>
    .profile-nav {
        background-color: rgb(79, 77, 91);
        list-style: none;
        margin: 0;
        padding: 8px 0;
    }

    .profile-nav__item + .profile-nav__item {
        margin-left: 15px;
    }

    .profile-nav__link {
        border-radius: 4px;
        color: rgba(255, 255, 255, .9);
        display: block;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
        padding: 2px 8px;
    }

    .profile-nav__link:hover,
    .profile-nav__link:active {
        color: rgba(255, 255, 255, .9);
        text-decoration: none;
    }

    .profile-nav__link.active {
        background-color: #f15a21;
    }

    .profile-title {
        color: rgba(0, 0, 0, .2);
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
        font-size: 1.25rem;
        text-align: center;
    }

    .profile-page-title {
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
        font-size: 1.75rem;
        margin-bottom: 20px;
        text-align: center;
    }

    .profile-container {
        background-color: #fff;
        padding: 20px 0 0;
    }
</style>
